import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview, analyticsActive } from "@/lib/analytics";

/**
 * Mounts inside <BrowserRouter> and fires a pageview to Plausible/GA
 * every time the SPA route changes.
 */
const AnalyticsListener = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (!analyticsActive) return;
    // Small delay so document.title has updated (helmet) before the event fires.
    const t = setTimeout(() => trackPageview(pathname + search), 50);
    return () => clearTimeout(t);
  }, [pathname, search]);
  return null;
};

export default AnalyticsListener;
